module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "MainView"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('v-touch', {
    staticClass: "logo-overlay",
    on: {
      "press": _vm.fastForwardTime,
      "pressup": _vm.resetClockDelay
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Pomodori Logo",
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "settings"
    },
    on: {
      "click": _vm.switchToSettingsView
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('radialBar', {
    attrs: {
      "fraction": _vm.fractionOfTimeLeft,
      "overlayText": _vm.overlayText,
      "size": _vm.radialBarSize,
      "strokeColor": _vm.primaryButton.bgColor,
      "trailColor": "#ABABAB"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "resetButton",
    attrs: {
      "label": "RESET",
      "color": _vm.primaryButton.bgColor
    },
    on: {
      "click": _vm.resetTimer
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "primaryButton",
    attrs: {
      "label": _vm.primaryButton.text,
      "backgroundColor": _vm.primaryButton.bgColor
    },
    on: {
      "click": _vm.primaryButton.callbackFn
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSettingsView),
      expression: "showSettingsView"
    }],
    staticClass: "SettingsView"
  }, [_c('settings', {
    ref: "settings",
    attrs: {
      "allowNotification": _vm.allowNotification,
      "breakDuration": _vm.breakDuration,
      "workDuration": _vm.workDuration
    },
    on: {
      "change": _vm.switchToMainView
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9c4990"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 86
// module chunks = 1